export const colors = {
  primary: "#18407D",
  gray: "#C4C4C4",
  green: "#48B632",
  lightGray: "#F4F4F4",
};
